import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActivateAccountComponent } from './auth/activate-account/activate-account.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { LoginComponent } from './auth/login/login.component';
import { RecoverPasswordComponent } from './auth/recover-password/recover-password.component';
import { AuthGuard } from './core/guard/auth.guard';
import { QrAuthGuard } from './core/guard/qr-auth.gaurd';
import {RemoveAccountComponent} from "./auth/remove-account/remove-account.component";


const routes: Routes = [
  {path:'login', component: LoginComponent},
  {path:'report-breach', canMatch:[QrAuthGuard], loadChildren: () => import('./auth/qr-code/qr-code-web.module').then(m => m.QrCodeWebModule)},
  {path:'forgot-password', component: ForgotPasswordComponent},
  {path:'recover-password/:token', component: RecoverPasswordComponent},
  {path:'activate-account/:token', component: ActivateAccountComponent},
  {path:'remove-account', component: RemoveAccountComponent},
  {path:'', canMatch:[AuthGuard], loadChildren: () => import('../app/main/main.module').then(m => m.MainModule)},
  {path:'**', redirectTo:'', pathMatch:'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
